import React, {useEffect} from 'react'
import {Link, NavLink, useNavigate} from 'react-router-dom'
import {LoginParam} from "../../../api/Login";
import {Button, Checkbox, Form, Input, Space, Layout, Flex, message} from 'antd';
import {useDispatch} from "react-redux";
import cookie from 'react-cookies';
import {createFromIconfontCN, LockOutlined, UserOutlined} from "@ant-design/icons";


import imageGif from '../../../assets/images/water.jpeg';
import companyLogo from '../../../assets/images/公司logo（无底色）.png';
import loginStyle from './style.module.css';


const LoginContain = (key, value) => {

  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();

  // const contentStyle = {
  //   textAlign: 'center',
  //   lineHeight: '100vh',
  //   height:'100vh',
  //   color: '#aaa',
  //   backgroundColor: '#fff',
  // };
  const siderStyle = {
    textAlign: 'center',
    lineHeight: '100vh',
    height: '100vh',
    color: '#fff',
    backgroundColor: '#fff',
    borderLeft: '1px #000 solid'
  };
  const layoutStyle = {
    borderRadius: 8,
    overflow: 'hidden',
    width: 'calc(50% - 8px)',
    maxWidth: 'calc(50% - 8px)',
  };

  const [loginForm] = Form.useForm();
  const history = useNavigate();


  const onFinish = (values) => {
    let params = {
      username: values.username,
      password: values.password
    }
    LoginParam(params).then(response => {
      if (response.data.status === 200) {

        messageApi.success('登录成功，即将跳转',3)

        //存储cookie
        if (values.remember) {
          let inFifteenMinutes = new Date(new Date().getTime() + 7 * 24 * 3600 * 1000);
          cookie.save("remember", values, {path: "/", expires: inFifteenMinutes});
        }else {
          cookie.remove("remember");
        }
        //等了成功后获取当前登录人所有的权限并存储在redux中
        console.log(response.data.data)
        const userInfo = {
          username: response.data.data.username,
          name: response.data.data.name,
          deptName: response.data.data.deptName,
          deptId: response.data.data.deptId
        }
        localStorage.setItem("userInfo", JSON.stringify(userInfo))
        let inFifteenMinutes = new Date(new Date().getTime() + 7 * 24 * 3600 * 1000);
        cookie.save("token",  response.data.token, {path: "/", expires: inFifteenMinutes});

        // localStorage.setItem("token", response.data.token)
        // dispatch({
        //   type: 'set',
        //   username:response.data.data.username
        // }
        // )
        history('/manage/dashboard')
        // PubSub.publish('isLoginSuccess', {
        //   to: '/main/dashboard',
        //   boolean: true
        // })
        // PubSub.publish('memberInfo',response.data[0])
      } else {
      }
    })
  };

  const onFinishFailed = (errorInfo) => {

  };

  useEffect(() => {

    console.log('重定向了')

    const hisCookie = cookie.load("remember")
    loginForm.setFieldsValue(hisCookie);

  }, [])


  return (
    <>{contextHolder}
      <Flex gap="middle" wrap="wrap">
        {/*<Content className={loginStyle.contentStyle} >*/}
        <img src={imageGif} className={loginStyle.loginImg}/>
        {/*</Content>*/}
        <Form
          form={loginForm}
          className={loginStyle.loginForm}
          onFinish={onFinish}

          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Space direction={"vertical"} className={loginStyle.spaceStyle}>
            <div className={loginStyle.contentStyle}>
              {/*<img src={companyLogo} className={loginStyle.logoImg}/>*/}
              <span className={loginStyle.spanStyle}> 首信一体化管理系统</span>
            </div>
            <Form.Item
              style={{
                height: '2.5vh'

              }}
              name={'username'}
              rules={[{required: true, message: '请输入用户名!'}]}
            >
              <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="用户名"/>
            </Form.Item>
            <Form.Item
              style={{
                height: '2.5vh'
              }}
              name={'password'}
              rules={[{required: true, message: '请输入密码!'}]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon"/>}
                type="password"
                placeholder="密码"
              />
            </Form.Item>

            <Space direction={"horizontal"} style={{height: '4vh'}}>
              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>
                <span className={loginStyle.loginCheck}>
                     记住密码
                </span>
                </Checkbox>
              </Form.Item>

              <Form.Item>
          <span className={loginStyle.loginForgot} onClick={() => {
            messageApi.info('请联系管理员!', 5)
          }}>
              <a>
            忘记密码
                </a>
          </span>

              </Form.Item>


            </Space>


            <Form.Item style={{height:"2.5vh"}}>
              <Button type="primary" htmlType="submit" className={loginStyle.loginButton}>
                登 录
              </Button>
            </Form.Item>
          </Space>
        </Form>

      </Flex>
      {/* 备案信息 */}
      <div style={{
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        textAlign: 'center',
        padding: '8px 0',
        fontSize: '12px',
        color: '#666',
        backgroundColor: '#fff',
        borderTop: '1px solid #e8e8e8',
        zIndex: 1000
      }}>
        <a 
          href="https://beian.miit.gov.cn" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: '#666', textDecoration: 'none' }}
        >
          蜀ICP备19027037号-2
        </a>
      </div>
    </>
  )
}

export default LoginContain
